export default __webpack_public_path__ + "2cd9095a7aae095477085bbdff985006.svg";